import { ISchemaError } from "../interfaces/ISchemaError/ISchemaError";
import { z } from "zod";

export const addressSchema = z.object({
  fullAddress: z.string({ invalid_type_error: ISchemaError.FULL_ADDRESS_INVALID_TYPE }).max(250, { message: ISchemaError.FULL_ADDRESS_TOO_LONG }).default(""),
  lat: z.number({ invalid_type_error: ISchemaError.LAT_INVALID_TYPE }).min(-90).max(90).default(0),
  lng: z.number({ invalid_type_error: ISchemaError.LNG_INVALID_TYPE }).min(-180).max(180).default(0),
});
